interface IFormikHelperProps {
    soMeExists: (name: string) => false | boolean[];
  }

const useFormikHelper = ():IFormikHelperProps  => {

    const soMeExists = (name:string) => {
        if(!name) {
            return false;
        }
        return ['facebook', 'twitter', 'linkedin'].map((value:string) => {
            return name.includes(value);
        });
    }

    return {soMeExists}
}

export default useFormikHelper